import { Inventory2Outlined } from '@mui/icons-material';

export const NoResults = ({ text, icon = true }) => (
    <div style={{ textAlign: 'center', padding: '20px' }}>
        {icon && <Inventory2Outlined fontSize='large' />}
        <p>{text || 'No hay resultados para mostrar'}</p>
    </div>
);